import type { LandingPageContent } from '../types'

export const FOTOVOLTAICA_WALLBOX_COCHE_ELECTRICO: LandingPageContent = {
  slug: 'fotovoltaica-wallbox-coche-electrico',
  lang: 'es',
  topicId: 'photovoltaik-wallbox-elektroauto',
  title: 'Wallbox y coche eléctrico: cargar con excedente solar en vez de gasolina',
  metaDescription:
    'Añada la wallbox directamente a su solicitud fotovoltaica, cargue su coche eléctrico con su ' +
    'propia energía solar - comparación de presupuestos gratis, sin lluvia de llamadas.',
  keywords: [
    'wallbox fotovoltaica',
    'coche eléctrico con carga solar',
    'cargar excedente fotovoltaico',
    'conducir gratis con fotovoltaica',
    'ahorrar combustible coche eléctrico',
    'comparar presupuestos wallbox',
  ],
  eyebrow: 'Wallbox + coche eléctrico',
  h1: 'Wallbox y coche eléctrico: cargar con excedente solar en vez de gasolina',
  intro:
    'Cargar un coche eléctrico con electricidad solar propia, en lugar de comprar electricidad de ' +
    'red cara o combustible, es una de las razones económicas más sólidas para tener una instalación ' +
    'fotovoltaica. En Roofora puede indicar una wallbox directamente en su solicitud fotovoltaica - ' +
    'gratis, sin tipo de solicitud separado, y comparar presupuestos de empresas verificadas sin ' +
    'lluvia de llamadas.',
  sections: [
    { type: 'heading', text: 'Cómo funciona la carga con excedente fotovoltaico' },
    {
      type: 'paragraph',
      text:
        'Con la carga por excedente, la wallbox carga preferentemente cuando la instalación ' +
        'fotovoltaica genera más electricidad de la que consume el hogar en ese momento - en lugar de ' +
        'verter el excedente a la red por pocos céntimos. Técnicamente se necesitan al menos unos ' +
        '1,4 kW de potencia fotovoltaica libre para carga monofásica, o unos 4,2 kW para carga ' +
        'trifásica (habitual en la mayoría de coches eléctricos modernos), normalmente gestionado por ' +
        'una wallbox "inteligente" con conmutación automática.',
    },
    { type: 'heading', text: 'Comparación de costes de combustible' },
    {
      type: 'list',
      items: [
        'Electricidad fotovoltaica: entre 1,44 y 2 € por 100 km (con 18-22 kWh/100 km y 8-12 cts/kWh de coste de generación)',
        'Electricidad de red: entre 4,50 y 6 € por 100 km (según el precio doméstico actual)',
        'Gasolina: unos 16,80 € por 100 km (con 8 l/100 km y 2,10 €/litro aproximadamente)',
      ],
    },
    {
      type: 'paragraph',
      text:
        'Estos valores son cifras orientativas externas del mercado (agosto de 2026), no un cálculo ' +
        'propio de Roofora - los precios de combustible y electricidad fluctúan, el ahorro real ' +
        'depende de su consumo y contrato individuales.',
    },
    { type: 'heading', text: 'Solicite la wallbox junto con su instalación' },
    {
      type: 'paragraph',
      text:
        'La wallbox no es un tipo de solicitud propio en Roofora, sino una opción dentro de su ' +
        'solicitud fotovoltaica: indique simplemente en el formulario que desea una wallbox (punto de ' +
        'carga para coche eléctrico), y las empresas instaladoras lo incluyen directamente en su ' +
        'presupuesto. De la misma forma, puede indicar que quiere cargar un coche eléctrico al ' +
        'dimensionar la instalación - esto influye en el tamaño recomendado de instalación y batería.',
    },
    { type: 'heading', text: '¿Y si ya tengo una instalación fotovoltaica?' },
    {
      type: 'paragraph',
      text:
        'Entonces basta con una solicitud de solo instalación eléctrica para añadir la wallbox, sin ' +
        'necesidad de licitar toda la instalación de nuevo.',
    },
  ],
  faq: [
    {
      q: '¿La opción de wallbox tiene algún coste adicional al solicitar?',
      a: 'No - como cualquier solicitud en Roofora, indicar la wallbox es gratis, recibirá presupuestos sin compromiso de varias empresas.',
    },
    {
      q: '¿Necesito una batería para cargar mi coche con energía solar?',
      a: 'No es imprescindible - la carga por excedente funciona también sin batería, mientras haya sol. Una batería ayuda además a cargar con electricidad propia fuera de las horas de sol.',
    },
    {
      q: 'Ya tengo wallbox, solo necesito la conexión eléctrica - ¿también es posible?',
      a: 'Sí - eso lo cubre el tipo de solicitud instalación eléctrica, independientemente de una instalación fotovoltaica completa.',
    },
  ],
  primaryCta: { label: 'Solicitar con wallbox', action: 'customer' },
  secondaryCta: { label: '¿Solo necesita añadir la wallbox?', action: 'link', href: '/instalacion-electrica-fotovoltaica' },
  relatedLinks: [
    { label: '¿Cuánto cuesta una instalación solar?', href: '/coste-instalacion-fotovoltaica' },
    { label: 'Cómo funciona la comparación de presupuestos', href: '/comparar-presupuestos-fotovoltaicos' },
    { label: '¿Solo necesita instalación eléctrica?', href: '/instalacion-electrica-fotovoltaica' },
  ],
}
